import { useState } from "react";
import { Plus } from "lucide-react";



import { AnnouncementFormData, StatusFilter, SystemAnnouncement } from "../../../../types/features/administration/SystemAnnouncement";
import { useAnnouncements } from "../../../../hooks/administration/annonces-system/useAnnouncements";
import { AnnouncementForm } from "../../../../components/features/administration/annonces-systeme/AnnouncementForm";
import { AnnouncementsList } from "../../../../components/features/administration/annonces-systeme/AnnouncementsList";

const AnnouncementsPage = () => {
  const {
    announcements,
    loading,
    statusFilter,
    setStatusFilter,
    createAnnouncement,
    updateAnnouncement,
    deleteAnnouncement,
  } = useAnnouncements();

  const [showModal, setShowModal] = useState(false);
  const [editingAnnouncement, setEditingAnnouncement] = useState<SystemAnnouncement | null>(null);

  const handleEdit = (announcement: SystemAnnouncement) => {
    setEditingAnnouncement(announcement);
    setShowModal(true);
  };

  console.log(announcements);

  const handleDelete = async (id: string) => {
    if (confirm("Êtes-vous sûr de vouloir supprimer cette annonce ?")) {
      await deleteAnnouncement(id);
    }
  };

  const handleSubmit = async (formData: AnnouncementFormData, imageFile: File | null) => {
    if (editingAnnouncement) {
      await updateAnnouncement(editingAnnouncement.id, formData, imageFile);
    } else {
      await createAnnouncement(formData, imageFile);
    }
    setShowModal(false);
    setEditingAnnouncement(null);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setEditingAnnouncement(null);
  };

  return (
      <div className="p-6">
        <div className="flex justify-between items-center mb-6">
          <div>
            <h1 className="text-2xl font-bold text-gray-900">Annonces Système</h1>
            <p className="text-gray-600">Gérez les annonces et alertes système</p>
          </div>
          <button
            onClick={() => setShowModal(true)}
            className="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
          >
            <Plus className="w-5 h-5" />
            Nouvelle Annonce
          </button>
        </div>

        <div className="mb-6">
          <select
            value={statusFilter}
            onChange={(e) => setStatusFilter(e.target.value as StatusFilter)}
            className="px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          >
            <option value="">Tous les statuts</option>
            <option value="ACTIVE">Actives</option>
            <option value="DESACTIVE">Désactivées</option>
          </select>
        </div>

        <AnnouncementsList
          announcements={announcements}
          loading={loading}
          onEdit={handleEdit}
          onDelete={handleDelete}
        />

        <AnnouncementForm
          isOpen={showModal}
          editingAnnouncement={editingAnnouncement}
          onSubmit={handleSubmit}
          onClose={handleCloseModal}
        />
      </div>
  );
};

export default AnnouncementsPage;
